import {IResourceComponentsProps, useShow, useTranslate} from "@refinedev/core";
import {IDevice, IMeasuringDeviceType} from "../../../rest-data-provider/bfaTypes";
import {Show, TagField} from "@refinedev/mui";
import {Chip, Grid, Stack, TextField, Typography} from "@mui/material";
import uniqolor from "uniqolor";
import React from "react";

export const DeviceShow: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const { queryResult } = useShow<IDevice>();
    const { data, isLoading } = queryResult;

    const record = data?.data;

    return (
        <Show isLoading={isLoading}>
            <Stack gap={2}>
                <TextField disabled={true} variant={"outlined"} label={translate('devices.fields.id')} defaultValue={" "} value={record?.id} />
                <TextField disabled={true} label={translate('devices.fields.name')} defaultValue={" "} value={record?.name} />
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextField fullWidth disabled={true} label={translate('devices.fields.sorting')} defaultValue={" "} value={record?.sorting} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth disabled={true} label={translate('devices.fields.defaultProtectionClass')} defaultValue={" "} value={record?.defaultProtectionClass ? record.defaultProtectionClass : '-'} />
                    </Grid>
                    <Grid item xs={6} style={{display: 'flex', flexDirection:'column', placeContent: 'center', alignContent:'center'}}>
                        <Typography variant="body1" fontWeight="bold">
                            {translate("devices.fields.image")}
                        </Typography>
                        <img
                            style={{ objectFit: 'contain', width: "100%", height: 200 }}
                            src={record?.image}
                        />
                    </Grid>
                    <Grid item xs={6} style={{}}>
                        <Typography variant="body1" fontWeight="bold">
                            {translate("devices.fields.categories")}
                        </Typography>
                        <Stack style={{margin: '5px'}} direction={'row'} gap={1} useFlexGap flexWrap="wrap">
                            {record && record.categories.length > 0 && record.categories.map(category => {
                                return (
                                    <Chip style={{backgroundColor: uniqolor(category.name, {lightness: 85}).color}} size={'medium'} key={category.id} label={category.name}></Chip>
                                )
                            })}
                            {record && record.categories.length === 0 && (
                                <Typography color={'grey'}>keine</Typography>
                            )}
                        </Stack>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth className={'unimportant'} disabled={true} label={translate('devices.fields.createdAt')} defaultValue={" "} value={record?.createdAt ? new Date(record!.createdAt).toLocaleString() : '-'} />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth className={'unimportant'} disabled={true} label={translate('devices.fields.updatedAt')} defaultValue={" "} value={record?.updatedAt ? new Date(record!.updatedAt).toLocaleString() : '-'} />
                    </Grid>
                </Grid>
            </Stack>
        </Show>
    );
};
